// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1010":"4a8a6c5d3996c96b","1279":"1e0d7904854fa562","2751":"20928d9c886051c8","3391":"a40829f404479ba4","6817":"682375ee3f8990d1","9941":"890709b4755daeea"}[chunkId] + ".css";
};